import { Fragment, memo } from 'react';
import PropTypes, { func, number, shape, string } from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { appointmentDraftSelectors, appointmentSelectors } from '~/api';
import { servicesSelectors } from '~/selectors';
import { selectAppointmentGiftAnswer } from '../../selectors';

import { TreatmentListDetails } from '../../../../components';
import { TreatmentDetails } from './treatment-details';

import { sumOfPrices } from '~/utils';

import styles from '../../../../components/treatment-list-details/TreatmentListDetails.scss';

const ReviewTreatmentListDetails = ({
  treatments,
  history,
  editModeConfig,
  isAppointmentGift = false,

  TotalPriceDetailsComponent: TotalPriceDetails = memo(() => null),
}) => (
  <Fragment>
    <TreatmentListDetails isMultipleAppointment={treatments.length > 1}>
      <ul className={styles.TreatmentList}>
        {treatments.map((treatment) => (
          <li
            key={treatment.name}
            className={classnames(styles.TreatmentItem)}
            data-testid="TreatmentItem"
          >
            <TreatmentDetails
              treatment={treatment}
              editModeConfig={editModeConfig}
              history={history}
            />
          </li>
        ))}
      </ul>
    </TreatmentListDetails>
    <TotalPriceDetails
      totalPrice={treatments.reduce((acc, treatment) => sumOfPrices(acc, treatment.price), '£0')}
      isAppointmentGift={isAppointmentGift}
    />
  </Fragment>
);

ReviewTreatmentListDetails.propTypes = {
  treatments: PropTypes.arrayOf(
    PropTypes.shape({
      name: string.isRequired,
      price: string.isRequired,
      dateSlot: string.isRequired,
      timeSlot: shape({
        from: number.isRequired,
        eventId: string,
      }).isRequired,
      partner: shape({
        id: string,
        name: string,
      }).isRequired,
      treatmentCategoryImageSrc: string,
    }),
  ).isRequired,
  history: shape({
    pushWithToken: func.isRequired,
  }).isRequired,
  editModeConfig: shape({
    firstEditPagePath: string,
  }).isRequired,
  isAppointmentGift: PropTypes.bool,

  TotalPriceDetailsComponent: PropTypes.elementType,
};

export const mapRelatedAppointments = (state) =>
  appointmentSelectors.selectRelatedAppointments(state).map((relatedAppointment) => ({
    id: appointmentDraftSelectors.selectRelatedAppointmentTypeById()(state).id,
    timeSlot: appointmentDraftSelectors.selectSelectedTimeSlotById(
      relatedAppointment.appointmentType.id,
    )(state),
    name: appointmentDraftSelectors.selectRelatedAppointmentTypeName(
      relatedAppointment.appointmentType.id,
    )(state),
    dateSlot: appointmentSelectors.selectAppointmentDateSlot(state),

    price: relatedAppointment.price,
    partner: relatedAppointment.partner,
    treatmentCategoryImageSrc: relatedAppointment.appointmentType.imageUrl,
  }));

export const mapStateToProps = (state) => ({
  treatments: [
    {
      id: appointmentDraftSelectors.selectAppointmentTypeId(state),
      timeSlot: appointmentDraftSelectors.selectAppointmentTimeSlot(state),
      name: appointmentDraftSelectors.selectAppointmentTypeName(state),

      price: appointmentSelectors.selectAppointmentTypePrice(state),
      dateSlot: appointmentSelectors.selectAppointmentDateSlot(state),
      partner: appointmentSelectors.selectAppointmentPartner(state),
      treatmentCategoryImageSrc: appointmentSelectors.selectAppointmentCategoryImage(state),
    },
  ].concat(mapRelatedAppointments(state)),

  editModeConfig: servicesSelectors.selectEditModeConfig(state),
  isAppointmentGift: selectAppointmentGiftAnswer(state),

  TotalPriceDetailsComponent:
    servicesSelectors.selectReviewFormConfig(state).TotalPriceDetailsComponent,
});

export const ConnectedTreatmentList = withRouter(
  connect(mapStateToProps)(memo(ReviewTreatmentListDetails)),
);
